import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import axios from "axios";
import Swal from "sweetalert2";
import { Container, Row } from "react-bootstrap";
import scgtlogo from "../assets/Images/scgt-logo.png";

const SCGTMembershipForm = () => {
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm();
  const [isSubmitting, setIsSubmitting] = useState(false);

  const statsData = [
    {
      value: "100+",
      title: "Global Chapters",
    },
    {
      value: "5,000+",
      title: "Global Members",
    },
    {
      value: "1,177,400+",
      title: "Member Referrals",
    },
    {
      value: "₹715,000+Cr",
      title: "Done Deals",
    },
  ];
  const onSubmit = async (data) => {
    setIsSubmitting(true);
    try {
      const formData = {
        scgt_first_name: data.firstName,
        scgt_last_name: data.lastName,
        scgt_email: data.email,
        scgt_mobile: data.phone,
        scgt_location: data.location,
        scgt_message: data.message || "",
      };

      const res = await axios.post(
        "https://api.vlsko.group/api/crm/scgt/add-scgt-inquiry",
        formData
      );

      if (res.data.status == "success") {
        Swal.fire({
          position: "center",
          icon: "success",
          title: "Inquiry sent successfully!",
          text: res.data.message,
          showConfirmButton: false,
          timer: 1500,
        });
        reset();
      } else {
        Swal.fire({
          position: "center",
          icon: "error",
          title: "Submission failed",
          text: res.data.message,
          showConfirmButton: false,
          timer: 1500,
        });
      }
    } catch (error) {
      Swal.fire({
        position: "center",
        icon: "error",
        title: "Submission failed",
        text: "Please try again later",
        showConfirmButton: false,
        timer: 1500,
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  const benefits = [
    {
      icon: "01",
      title: "Connect",
      description:
        "At SCGT, we bring together like-minded professionals from across the globe, fostering meaningful connections that lead to lasting partnerships. Our members enjoy unparalleled networking opportunities that open doors to new business ventures.",
    },
    {
      icon: "02",
      title: "Collaborate",
      description:
        "SCGT thrives on the power of collaboration, where members work together to create innovative solutions and drive business growth. By sharing knowledge, resources, and expertise, we build a community that supports each other's ambitions.",
    },
    {
      icon: "03",
      title: "Grow",
      description:
        "SCGT is dedicated to helping you grow your business and your professional skills through targeted referrals, mentorship, and continuous learning. As part of our network, you'll gain access to opportunities that accelerate your growth.",
    },
  ];

  return (
    <>
      <div
        className="min-vh-100 py-5"
        style={{
          background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
        }}
      >
        <div className="container">
          <div className="d-flex align-items-center pb-4">
            <img
              src={scgtlogo}
              alt="SCGT Logo"
              className="img-fluid"
              style={{ maxWidth: "300px", height: "auto" }}
            />
          </div>
          <div className="row g-5">
            <div className="col-lg-6">
              <div className="text-white pe-lg-4">
                <h1 className="display-5 text-white fw-bold mb-4">
                  Why Join SCGT?
                </h1>
                <p className="fs-5 mb-5 opacity-75">
                  Join SCGT to unlock unparalleled networking opportunities,
                  gain valuable business interests, and collaborate with a
                  global community of driven professionals dedicated to mutual
                  success.
                </p>

                <div className="d-flex flex-column gap-4">
                  {benefits.map((benefit, index) => (
                    <div
                      key={index}
                      className="p-4 rounded-3 transition-all"
                      style={{
                        color: "rgba(255, 255, 255, 0.7)",
                        backgroundColor: "transparent",
                        border: "1px solid rgba(255, 255, 255, 0.25)",
                        transition: "all 0.3s ease",
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.color = "#4F547B";
                        e.currentTarget.style.backgroundColor = "#FFFFFF";
                        e.currentTarget.style.borderColor = "#FFFFFF";
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.color =
                          "rgba(255, 255, 255, 0.7)";
                        e.currentTarget.style.backgroundColor = "transparent";
                        e.currentTarget.style.borderColor =
                          "rgba(255, 255, 255, 0.25)";
                      }}
                    >
                      <div className="d-flex align-items-start gap-4">
                        <div
                          className="rounded-circle d-flex align-items-center justify-content-center"
                          style={{
                            width: "50px",
                            height: "50px",
                            flexShrink: 0,
                            backgroundColor: "#FFFFFF",
                            color: "#6f42c1",
                          }}
                        >
                          <span className="fs-5 fw-bold">{benefit.icon}</span>
                        </div>
                        <div>
                          <h3
                            className="h4 fw-bold mb-3"
                            style={{ color: "inherit" }}
                          >
                            {benefit.title}
                          </h3>
                          <p
                            className="mb-0"
                            style={{ opacity: 0.75, color: "inherit" }}
                          >
                            {benefit.description}
                          </p>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="bg-white rounded-4 shadow-lg p-4 p-md-5">
                <h2 className="h3 fw-bold mb-4 text-purple">
                  Membership Enquiry Form
                </h2>

                <form onSubmit={handleSubmit(onSubmit)}>
                  {/* Name Fields */}
                  <div className="mb-3">
                    <label className="form-label fw-bold">Name*</label>
                    <div className="row g-2">
                      <div className="col-md-6">
                        <input
                          type="text"
                          className={`form-control form-control-lg ${
                            errors.firstName ? "is-invalid" : ""
                          }`}
                          placeholder="First"
                          {...register("firstName", { required: true })}
                        />
                        {errors.firstName && (
                          <div className="invalid-feedback">
                            First name is required
                          </div>
                        )}
                      </div>
                      <div className="col-md-6">
                        <input
                          type="text"
                          className={`form-control form-control-lg ${
                            errors.lastName ? "is-invalid" : ""
                          }`}
                          placeholder="Last"
                          {...register("lastName", { required: true })}
                        />
                        {errors.lastName && (
                          <div className="invalid-feedback">
                            Last name is required
                          </div>
                        )}
                      </div>
                    </div>
                  </div>

                  {/* Email Field */}
                  <div className="mb-3">
                    <label className="form-label fw-bold">Email*</label>
                    <input
                      type="email"
                      className={`form-control form-control-lg ${
                        errors.email ? "is-invalid" : ""
                      }`}
                      placeholder="Enter your email"
                      {...register("email", {
                        required: true,
                        pattern: /^\S+@\S+$/i,
                      })}
                    />
                    {errors.email && (
                      <div className="invalid-feedback">
                        {errors.email.type === "required"
                          ? "Email is required"
                          : "Invalid email address"}
                      </div>
                    )}
                  </div>

                  {/* Phone Field */}
                  <div className="mb-3">
                    <label className="form-label fw-bold">Number*</label>
                    <input
                      type="tel"
                      className={`form-control form-control-lg ${
                        errors.phone ? "is-invalid" : ""
                      }`}
                      placeholder="Enter your phone number"
                      {...register("phone", { required: true })}
                    />
                    {errors.phone && (
                      <div className="invalid-feedback">
                        Phone number is required
                      </div>
                    )}
                  </div>

                  {/* Location Field */}
                  <div className="mb-3">
                    <label className="form-label fw-bold">Location/City*</label>
                    <input
                      type="text"
                      className={`form-control form-control-lg ${
                        errors.location ? "is-invalid" : ""
                      }`}
                      placeholder="Enter your city"
                      {...register("location", { required: true })}
                    />
                    {errors.location && (
                      <div className="invalid-feedback">
                        Location is required
                      </div>
                    )}
                  </div>

                  {/* Message Field */}
                  <div className="mb-3">
                    <label className="form-label fw-bold">
                      Comment or Message
                    </label>
                    <textarea
                      className="form-control form-control-lg"
                      rows="4"
                      placeholder="Enter your message"
                      {...register("message")}
                    ></textarea>
                  </div>
                  <button
                    type="submit"
                    className="btn btn-primary btn-lg w-100 py-3 fw-bold"
                    disabled={isSubmitting}
                    style={{ background: "#6f42c1", borderColor: "#6f42c1" }}
                  >
                    {isSubmitting ? (
                      <>
                        <span
                          className="spinner-border spinner-border-sm me-2"
                          role="status"
                        ></span>
                        Submitting...
                      </>
                    ) : (
                      "Submit"
                    )}
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
      <section className="py-5" style={{ backgroundColor: "#6440FB" }}>
        <Container>
          <Row className="g-4">
            {statsData.map((stat, index) => (
              <div
                key={index}
                className="col-12 col-sm-6 col-md-4 col-lg-3 mb-4"
              >
                <div className="card h-100 p-3 shadow-sm">
                  <div className="card-body text-center">
                    <h3 className="card-title fs-2 fw-bold mb-2">
                      {stat.value}
                    </h3>
                    <p className="card-text text-muted">{stat.title}</p>
                  </div>
                </div>
              </div>
            ))}
          </Row>
        </Container>
      </section>
    </>
  );
};

export default SCGTMembershipForm;
